document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".add-to-cart-archive-button");

  buttons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      const product_id = this.dataset.product_id;

      const formData = new FormData();
      formData.append("action", "woocommerce_add_to_cart");
      formData.append("product_id", product_id);
      formData.append("quantity", 1);

      fetch(wc_add_to_cart_params.ajax_url, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.error && data.product_url) {
            window.location.href = data.product_url;
            return;
          }

          const originalText = button.innerHTML;
          button.innerText = "Dodano do koszyka!";
          setTimeout(() => {
            button.innerHTML = originalText;
          }, 8000);

          document.body.dispatchEvent(new CustomEvent("wc_fragment_refresh"));

          const modal = document.querySelector(".xoo-wsc-modal");
          if (modal) {
            modal.classList.add("xoo-wsc-cart-active");
          }
        })
        .catch((error) => console.error("Błąd dodawania do koszyka:", error));
    });
  });
});
